import {
  GET_EMPLOYEE_FAMILY,
  UPDATE_PARENT_INFO,
  UPDATE_SPOUSE_INFO,
  UPDATE_CHILDREN_INFO,
  UPDATE_EMERGENCY_CONTACT_INFO,
  UPDATE_PERMANENT_ADDRESS_INFO,
  UPDATE_PRESENT_ADDRESS_INFO,
  DELETE_SPOUSE_INFO,
  DELETE_CHILD_INFO,
} from "./types";
import {
  FamilyType,
  ParentType,
  SpouseType,
  ChildType,
  EmergencyContactType,
  PermanentAddressType,
  PresentAddressType,
} from "@type/HRM/family";

export const getFamilyRequest = (data: number | null) => {
  return {
    type: GET_EMPLOYEE_FAMILY.GET_FAMILY_REQUEST,
    payload: { data },
  } as const;
};

export const getFamilySuccess = (data: FamilyType) => {
  return {
    type: GET_EMPLOYEE_FAMILY.GET_FAMILY_SUCCESS,
    payload: { data },
  } as const;
};

export const getFamilyFailed = () => {
  return {
    type: GET_EMPLOYEE_FAMILY.GET_FAMILY_FAILED,
  } as const;
};

export const updateParentInfoRequest = (data: ParentType) => {
  return {
    type: UPDATE_PARENT_INFO.UPDATE_PARENT_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateParentInfoSuccess = (data: ParentType) => {
  return {
    type: UPDATE_PARENT_INFO.UPDATE_PARENT_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateParentInfoFailed = () => {
  return {
    type: UPDATE_PARENT_INFO.UPDATE_PARENT_INFO_FAILED,
  } as const;
};

export const updateSpouseInfoRequest = (data: SpouseType) => {
  return {
    type: UPDATE_SPOUSE_INFO.UPDATE_SPOUSE_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateSpouseInfoSuccess = (data: SpouseType) => {
  return {
    type: UPDATE_SPOUSE_INFO.UPDATE_SPOUSE_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateSpouseInfoFailed = () => {
  return {
    type: UPDATE_SPOUSE_INFO.UPDATE_SPOUSE_INFO_FAILED,
  } as const;
};

export const updateChildrenInfoRequest = (data: ChildType) => {
  return {
    type: UPDATE_CHILDREN_INFO.UPDATE_CHILDREN_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateChildrenInfoSuccess = (data: ChildType) => {
  return {
    type: UPDATE_CHILDREN_INFO.UPDATE_CHILDREN_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateChildrenInfoFailed = () => {
  return {
    type: UPDATE_CHILDREN_INFO.UPDATE_CHILDREN_INFO_FAILED,
  } as const;
};

export const updateEmergencyContactInfoRequest = (
  data: EmergencyContactType,
) => {
  return {
    type: UPDATE_EMERGENCY_CONTACT_INFO.UPDATE_EMERGENCY_CONTACT_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateEmergencyContactInfoSuccess = (
  data: EmergencyContactType,
) => {
  return {
    type: UPDATE_EMERGENCY_CONTACT_INFO.UPDATE_EMERGENCY_CONTACT_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateEmergencyContactInfoFailed = () => {
  return {
    type: UPDATE_EMERGENCY_CONTACT_INFO.UPDATE_EMERGENCY_CONTACT_INFO_FAILED,
  } as const;
};

export const updatePermanentAddressInfoRequest = (
  data: PermanentAddressType,
) => {
  return {
    type: UPDATE_PERMANENT_ADDRESS_INFO.UPDATE_PERMANENT_ADDRESS_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updatePermanentAddressInfoSuccess = (
  data: PermanentAddressType,
) => {
  return {
    type: UPDATE_PERMANENT_ADDRESS_INFO.UPDATE_PERMANENT_ADDRESS_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updatePermanentAddressInfoFailed = () => {
  return {
    type: UPDATE_PERMANENT_ADDRESS_INFO.UPDATE_PERMANENT_ADDRESS_INFO_FAILED,
  } as const;
};

export const updatePresentAddressInfoRequest = (data: PresentAddressType) => {
  return {
    type: UPDATE_PRESENT_ADDRESS_INFO.UPDATE_PRESENT_ADDRESS_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updatePresentAddressInfoSuccess = (data: PresentAddressType) => {
  return {
    type: UPDATE_PRESENT_ADDRESS_INFO.UPDATE_PRESENT_ADDRESS_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updatePresentAddressInfoFailed = () => {
  return {
    type: UPDATE_PRESENT_ADDRESS_INFO.UPDATE_PRESENT_ADDRESS_INFO_FAILED,
  } as const;
};

export const deleteChildInfoRequest = (data: {
  childID: number;
  employeeID: number | null;
}) => {
  return {
    type: DELETE_CHILD_INFO.DELETE_CHILD_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteChildInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_CHILD_INFO.DELETE_CHILD_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteChildInfoFailed = () => {
  return {
    type: DELETE_CHILD_INFO.DELETE_CHILD_INFO_FAILED,
  } as const;
};

export const deleteSpouseInfoRequest = (data: {
  spouseID: number;
  employeeID: number | null;
}) => {
  return {
    type: DELETE_SPOUSE_INFO.DELETE_SPOUSE_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteSpouseInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_SPOUSE_INFO.DELETE_SPOUSE_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteSpouseInfoFailed = () => {
  return {
    type: DELETE_SPOUSE_INFO.DELETE_SPOUSE_INFO_FAILED,
  } as const;
};

export type FamilyActions =
  | ReturnType<typeof getFamilyRequest>
  | ReturnType<typeof getFamilySuccess>
  | ReturnType<typeof getFamilyFailed>
  | ReturnType<typeof updateParentInfoRequest>
  | ReturnType<typeof updateParentInfoSuccess>
  | ReturnType<typeof updateParentInfoFailed>
  | ReturnType<typeof updateSpouseInfoRequest>
  | ReturnType<typeof updateSpouseInfoSuccess>
  | ReturnType<typeof updateSpouseInfoFailed>
  | ReturnType<typeof deleteSpouseInfoRequest>
  | ReturnType<typeof deleteSpouseInfoSuccess>
  | ReturnType<typeof deleteSpouseInfoFailed>
  | ReturnType<typeof updateChildrenInfoRequest>
  | ReturnType<typeof updateChildrenInfoSuccess>
  | ReturnType<typeof updateChildrenInfoFailed>
  | ReturnType<typeof deleteChildInfoRequest>
  | ReturnType<typeof deleteChildInfoSuccess>
  | ReturnType<typeof deleteChildInfoFailed>
  | ReturnType<typeof updateEmergencyContactInfoRequest>
  | ReturnType<typeof updateEmergencyContactInfoSuccess>
  | ReturnType<typeof updateEmergencyContactInfoFailed>
  | ReturnType<typeof updatePermanentAddressInfoRequest>
  | ReturnType<typeof updatePermanentAddressInfoSuccess>
  | ReturnType<typeof updatePermanentAddressInfoFailed>
  | ReturnType<typeof updatePresentAddressInfoRequest>
  | ReturnType<typeof updatePresentAddressInfoSuccess>
  | ReturnType<typeof updatePresentAddressInfoFailed>;